module.exports = __webpack_public_path__ + "img/borderInvertedTriangleWhite.7bf97e61.svg";